// Polyfills for js features used in the Dashboard but not supported in some browsers (mainly IE)
import '@/polyfills';
// Notifications plugin. Used on Notifications page
import Notifications from '@/components/NotificationPlugin';
// Validation plugin used to validate forms
import VeeValidate, { Validator } from 'vee-validate';
import attributesEs from 'vee-validate/dist/locale/es';
// A plugin file where you could register global components used across the app
import GlobalComponents from './dashboard/globalComponents';
// A plugin file where you could register global directives
import GlobalDirectives from './dashboard/globalDirectives';
// A plugin file where you could register global filters
import GlobalFilters from './dashboard/globalFilters';
// A plugin file where you could register global filters
import GlobalHelpers from './dashboard/globalHelpers';
// Sidebar on the right. Used as a local plugin in DashboardLayout.vue
import SideBar from '@/components/SidebarPlugin';

import Loading from '@/plugins/dashboard/loading';

// element ui language configuration
import lang from 'element-ui/lib/locale/lang/es';
import locale from 'element-ui/lib/locale';

locale.use(lang);

Validator.localize('es', attributesEs);

// asset imports
import '@/assets/sass/argon.scss';
import '@/assets/css/nucleo/css/nucleo.css';

export default {
  install(Vue) {
    Vue.use(GlobalComponents);
    Vue.use(GlobalDirectives);
    Vue.use(GlobalFilters);
    Vue.use(GlobalHelpers);
    Vue.use(Loading);
    Vue.use(SideBar);
    Vue.use(Notifications);
    Vue.use(VeeValidate, {
      fieldsBagName: 'veeFields',
      classes: true,
      validity: true,
      classNames: {
        valid: 'is-valid',
        invalid: 'is-invalid',
      },
      locale: 'es',
      dictionary: {
        es: {
          attributes: {
            name: 'nombre',
            address: 'dirección',
            city: 'ciudad',
            phone: 'teléfono',
            province: 'provincia',
            businessName: 'razón social',
            seedDate: 'fecha de siembra',
            harvestDate: 'fecha de cosecha',
            chopDate: 'fecha de picado',
            fromDate: 'fecha desde',
            toDate: 'fecha hasta',
            startDate: 'fecha de inicio',
            endDate: 'fecha de fin',
            date: 'fecha',
            from: 'desde',
            to: 'hasta',
            year: 'año',
            month: 'mes',
            day: 'día',
            hour: 'hora',
            details: 'detalles',
            detail: 'detalle',
            crop: 'cultivo',
            crops: 'cultivos',
            seller: 'asesor técnico',
            distributor: 'distribuidor',
            producer: 'productor',
            field: 'campo',
            plot: 'lote',
            unit: 'unidad',
            hectares: 'hectareas',
            groovesDistance: 'distancia entre surcos',
            nitrogenFertilization: 'fertilización nitrogenada',
            phosphateFertilization: 'fertilización fosfatada',
            weedControl: 'control de malezas',
            pestControl: 'control de plagas',
            comment: 'comentario',
            plantsDensity: 'densidad de plantas',
            hailStorms: 'granizo',
            rainfall: 'precipitaciones',
            averageTemperature: 'temperaturas promedio',
            heatStrokes: 'golpes de calor',
            frost: 'heladas',
            tizon: 'tizon',
            helminthosporium: 'helminthosporium',
            roya: 'roya',
            cornStreak: 'rayado fino',
            chopperMachine: 'maquina picadora',
            storagePerformance: 'rendimiento',
            harvestPerformance: 'rendimiento de cosecha',
            inoculantBrand: 'marca inoculante',
            type: 'tipo',
            documentType: 'tipo de documento',
            document: 'documento',
            entityType: 'tipo de individuo',
            entity: 'individuo',
            receiptTypeId: 'Tipo de Comprobante',
            orderId: 'Pedido',
            campaign: 'campaña',
            variety: 'variedad',
            competitorVariety: 'variedad competidora',
            competitorQuantity: 'cantidad competidora',
            quantity: 'cantidad',
            firstPaymentDate: 'fecha primer pago',
            billingDate: 'fecha de facturación',
            payments: 'cantidad de pagos',
            dollarQuote: 'cotización dólar',
            dollarQuoteDate: 'fecha cotización dólar',
            statusChangeComment: 'comentario cambio de estado',
            state: 'estado',
            article: 'artículo',
            price: 'precio',
            daysToHarvest: 'días a cosecha',
            daysToChop: 'días a picado',
            plantHeight: 'altura de plantas',
            spikeInsertion: 'inserción de espiga',
            documentName: 'nombre del documento',
            seedsPerMeter: 'semillas por metro',
            productionDestination: 'destino producción',
            visitNextDate: 'fecha próxima visita',
            visitDate: 'fecha visita',
            distributorCost: 'costo de distribuidor',
            amountInPesos: 'importe en pesos',
            amountInDollars: 'importe en dolares',
            conceptPaymentType: 'tipo de concepto de pago',
            number: 'número',
            bank: 'banco',
            postalCode: 'código postal',
            accreditationDate: 'fecha de acreditación',
            liquidation: 'liquidación',
            invoiceNumber: 'N° de Factura',
          },
        },
      },
    });
  },
};
